import { QuestionAnswerDto } from "api/borrower";
import { RealEstateDto } from "api/real-estate";
import { BranchCode } from "api/risk";
import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { realEstateAPI } from "services/swagger-api/realEstateAPI";

export const useRealEstateRequest = (branchCode: BranchCode) => {
  const [realEstate, setRealEstate] = useState<RealEstateDto | undefined>();
  const [questionAnswers, setQuestionAnswers] = useState<QuestionAnswerDto[] | undefined>();

  const fetchRealEstateById = useCallback(
    async (realEstateId: string) => {
      try {
        // TO REFACTO: Request only the questionnary
        const response = await realEstateAPI.getRealEstateById({
          bienId: realEstateId,
          includeQuestionnaire: branchCode === BranchCode.UPI,
          codeBranche: branchCode
        });

        if (response) {
          setRealEstate(response.realEstate);
          if (response.surveyAnswers) {
            setQuestionAnswers(response.surveyAnswers);
          }
        }
      } catch (error: any) {
        console.error("Error fetching real estate:", error);
        toast.error(error?.response?.error?.message || "Error loading real estate data");
      }

    }, [branchCode]);

  return {
    fetchRealEstateById,
    realEstate,
    questionAnswers
  }
}
